<template>
  <Popup
    :show="modelValue"
    :close-on-click-overlay="closable"
    :close-on-popstate="closable"
    style="background: transparent;"
    @close="onClose"
  >
    <div class="hw-dialog-wrap" :class="fontClass">
      <div class="hw-dialog" :class="{ 'hw-dialog-long': size === 'long' }">
        <slot></slot>
        <img
          v-if="closable"
          class="hw-dialog-close"
          src="~@/views/act/halloween/assets/img/close.png"
          alt="close"
          @click="emit('update:modelValue', false)"
        >
      </div>
    </div>
  </Popup>
</template>

<script setup>
import { computed } from 'vue'
import { Popup } from 'vant'
import { useI18n } from 'vue-i18n'
import { defineProps, defineEmits } from 'vue'
import { halloweenFontClass } from '@/views/act/halloween/assets/fonts/fontClass'

const emit = defineEmits(['update:modelValue', 'close'])
const { locale } = useI18n()
const fontClass = computed(() => halloweenFontClass(locale.value))

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  size: {
    type: String,
    default: 'normal', // normal / long
  },
  closable: {
    type: Boolean,
    default: true,
  },
})

const onClose = () => {
  if (!props.closable) return
  emit('update:modelValue', false)
  emit('close')
}
</script>

<style scoped lang="less">
.van-popup--center {
  max-width: 100% !important;
}
.hw-dialog-wrap {
  padding: 50px;
  .hw-dialog {
    width: 666px;
    height: 534px;
    background: url('~@/views/act/halloween/assets/img/dialog-bg.png') no-repeat center center / 100% 100%;
    position: relative;
    margin-left: -10px;;
    .hw-dialog-close {
      position: absolute;
      top: -25px;
      right: -25px;
      width: 52px;
      height: 52px;
      cursor: pointer;
    }
  }
  .hw-dialog-long {
    width: 666px;
    height: 839px;
    background: url('~@/views/act/halloween/assets/img/dialog-long-bg.png') no-repeat center center / 100% 100%;
  }
}
</style>
